import { clsx } from 'clsx';

/** Per-cell classes so row highlight works (td backgrounds override tr). Gray band like Summary detailed breakdown. */
export function poolReportSelectedCellClass(isSelected: boolean): string {
  return isSelected
    ? clsx(
        '!bg-gray-100 dark:!bg-dark-800/90',
        'shadow-[inset_0_0_0_1px_rgb(209,213,219)] dark:shadow-[inset_0_0_0_1px_rgb(71,85,105)]'
      )
    : '';
}

export const poolReportOwnerLabelClass =
  'whitespace-normal break-words text-right text-sm font-semibold uppercase leading-snug text-gray-900 dark:text-white sm:text-base';

/** Reset default <button> padding so label + icon align like Net allocation. */
export const poolReportOwnerLinkClass =
  'bg-transparent p-0 text-primary-700 underline decoration-primary-600/50 underline-offset-2 shadow-none hover:text-primary-800 hover:no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:text-sky-300 dark:decoration-sky-400/50 dark:focus-visible:ring-sky-400 dark:focus-visible:ring-offset-dark-900';
